import fromEnum from '@/scripts/io-ts/fromEnum';

export enum Ringtone {
    TIME_EXPIRED = 'time_expired',
    SESSION_COMPLETE = 'session_complete',

    ONE_MINUTE_REMAINING = 'one_minute_remaining',
    TWO_MINUTES_REMAINING = 'two_minutes_remaining',
    THREE_MINUTES_REMAINING = 'three_minutes_remaining',
    FIVE_MINUTES_REMAINING = 'five_minutes_remaining',
    TEN_MINUTES_REMAINING = 'ten_minutes_remaining',
    FIFTEEN_MINUTES_REMAINING = 'fifteen_minutes_remaining',
    THIRTY_MINUTES_REMAINING = 'thirty_minutes_remaining',
    ONE_HOUR_REMAINING = 'one_hour_remaining',

    ALERT_UP = 'alert_up',
    ALERT_DOWN = 'alert_down',
    SOAR_TONE = 'soar_tone',
}

export const RingtoneC = fromEnum('Ringtone', Ringtone);
